var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.039,
    height: 20.934,
    viewBox: "0 0 27.039 20.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_course0",
    "data-name": "Online course0",
    transform: "translate(-8 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M32.859,64H13.67a2.184,2.184,0,0,0-2.143,1.782,2.186,2.186,0,0,0-1.744,1.744A2.184,2.184,0,0,0,8,69.67V82.753a2.183,2.183,0,0,0,2.181,2.181H29.37a2.184,2.184,0,0,0,2.143-1.782,2.186,2.186,0,0,0,1.744-1.744,2.184,2.184,0,0,0,1.782-2.143V66.181A2.183,2.183,0,0,0,32.859,64ZM8.872,69.67a1.31,1.31,0,0,1,1.308-1.308H29.37a1.31,1.31,0,0,1,1.308,1.308v.436H8.872ZM30.678,82.753a1.31,1.31,0,0,1-1.308,1.308H10.181a1.31,1.31,0,0,1-1.308-1.308V70.978H30.678Zm1.744-1.744a1.31,1.31,0,0,1-.872,1.233V69.67a2.183,2.183,0,0,0-2.181-2.181H10.692a1.31,1.31,0,0,1,1.233-.872H31.114a1.31,1.31,0,0,1,1.308,1.308Zm1.744-1.744a1.31,1.31,0,0,1-.872,1.233V67.925a2.183,2.183,0,0,0-2.181-2.181H12.436a1.31,1.31,0,0,1,1.233-.872H32.859a1.31,1.31,0,0,1,1.308,1.308Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 0.587,
    cy: 0.391,
    rx: 0.587,
    ry: 0.391,
    transform: "translate(9.565 68.695)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 0.391,
    cy: 0.391,
    r: 0.391,
    transform: "translate(11.522 68.695)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 0.587,
    cy: 0.391,
    rx: 0.587,
    ry: 0.391,
    transform: "translate(13.087 68.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M128.436,223.85h9.595a.436.436,0,0,0,.436-.436v-6.978a.436.436,0,0,0-.436-.436h-9.595a.436.436,0,0,0-.436.436v6.978A.436.436,0,0,0,128.436,223.85Zm.436-6.978h8.722v6.106h-8.722Z",
    transform: "translate(-113.458 -143.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M200.224,243.432a.436.436,0,0,0,.441-.009l2.126-1.308a.436.436,0,0,0,0-.743l-2.126-1.308a.436.436,0,0,0-.665.371v2.617A.436.436,0,0,0,200.224,243.432Zm.649-2.217.858.528-.858.528Z",
    transform: "translate(-181.533 -166.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    "data-name": "Path 4338",
    d: "M166.542,304.436h-.872a.436.436,0,0,0-.872,0h-4.361a.436.436,0,0,0,0,.872H164.8a.436.436,0,0,0,.872,0h.872a.436.436,0,0,0,0-.872Z",
    transform: "translate(-143.714 -226.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    d: "M128.436,368.872h9.595a.436.436,0,1,0,0-.872h-9.595a.436.436,0,1,0,0,.872Z",
    transform: "translate(-113.458 -287.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    d: "M128.436,392.872h6.106a.436.436,0,1,0,0-.872h-6.106a.436.436,0,1,0,0,.872Z",
    transform: "translate(-113.458 -310.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M264.872,392h-.436a.436.436,0,1,0,0,.872h.436a.436.436,0,1,0,0-.872Z",
    transform: "translate(-242.044 -310.119)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.a35999fbf83d6daacc90e699181410a6.svg";
export { ForwardRef as ReactComponent };